var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('calendar',{ref:"calendarRef",attrs:{"allow-add":false},on:{"fetchEvents":_vm.fetchEvents,"eventClick":_vm.eventClick,"dateClick":_vm.dateClick,"selectDateRange":_vm.selectDateRange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }